// Mapping from country names to ISO country codes for phone input
export const countryToPhoneCode: Record<string, string> = {
  'afghanistan': 'af',
  'albania': 'al',
  'algeria': 'dz',
  'andorra': 'ad',
  'angola': 'ao',
  'antigua-and-barbuda': 'ag',
  'argentina': 'ar',
  'armenia': 'am',
  'australia': 'au',
  'austria': 'at',
  'azerbaijan': 'az',
  'bahamas': 'bs',
  'bahrain': 'bh',
  'bangladesh': 'bd',
  'barbados': 'bb',
  'belarus': 'by',
  'belgium': 'be',
  'belize': 'bz',
  'benin': 'bj',
  'bhutan': 'bt',
  'bolivia': 'bo',
  'bosnia-and-herzegovina': 'ba',
  'botswana': 'bw',
  'brazil': 'br',
  'brunei': 'bn',
  'bulgaria': 'bg',
  'burkina-faso': 'bf',
  'burundi': 'bi',
  'cambodia': 'kh',
  'cameroon': 'cm',
  'canada': 'ca',
  'cape-verde': 'cv',
  'central-african-republic': 'cf',
  'chad': 'td',
  'chile': 'cl',
  'china': 'cn',
  'colombia': 'co',
  'comoros': 'km',
  'congo': 'cg',
  'costa-rica': 'cr',
  'croatia': 'hr',
  'cuba': 'cu',
  'cyprus': 'cy',
  'czech-republic': 'cz',
  'denmark': 'dk',
  'djibouti': 'dj',
  'dominica': 'dm',
  'dominican-republic': 'do',
  'ecuador': 'ec',
  'egypt': 'eg',
  'el-salvador': 'sv',
  'equatorial-guinea': 'gq',
  'eritrea': 'er',
  'estonia': 'ee',
  'eswatini': 'sz',
  'ethiopia': 'et',
  'fiji': 'fj',
  'finland': 'fi',
  'france': 'fr',
  'gabon': 'ga',
  'gambia': 'gm',
  'georgia': 'ge',
  'germany': 'de',
  'ghana': 'gh',
  'greece': 'gr',
  'grenada': 'gd',
  'guatemala': 'gt',
  'guinea': 'gn',
  'guinea-bissau': 'gw',
  'guyana': 'gy',
  'haiti': 'ht',
  'honduras': 'hn',
  'hungary': 'hu',
  'iceland': 'is',
  'india': 'in',
  'indonesia': 'id',
  'iran': 'ir',
  'iraq': 'iq',
  'ireland': 'ie',
  'israel': 'il',
  'italy': 'it',
  'jamaica': 'jm',
  'japan': 'jp',
  'jordan': 'jo',
  'kazakhstan': 'kz',
  'kenya': 'ke',
  'kiribati': 'ki',
  'kuwait': 'kw',
  'kyrgyzstan': 'kg',
  'laos': 'la',
  'latvia': 'lv',
  'lebanon': 'lb',
  'lesotho': 'ls',
  'liberia': 'lr',
  'libya': 'ly',
  'liechtenstein': 'li',
  'lithuania': 'lt',
  'luxembourg': 'lu',
  'madagascar': 'mg',
  'malawi': 'mw',
  'malaysia': 'my',
  'maldives': 'mv',
  'mali': 'ml',
  'malta': 'mt',
  'marshall-islands': 'mh',
  'mauritania': 'mr',
  'mauritius': 'mu',
  'mexico': 'mx',
  'micronesia': 'fm',
  'moldova': 'md',
  'monaco': 'mc',
  'mongolia': 'mn',
  'montenegro': 'me',
  'morocco': 'ma',
  'mozambique': 'mz',
  'myanmar': 'mm',
  'namibia': 'na',
  'nauru': 'nr',
  'nepal': 'np',
  'netherlands': 'nl',
  'new-zealand': 'nz',
  'nicaragua': 'ni',
  'niger': 'ne',
  'nigeria': 'ng',
  'north-korea': 'kp',
  'north-macedonia': 'mk',
  'norway': 'no',
  'oman': 'om',
  'pakistan': 'pk',
  'palau': 'pw',
  'panama': 'pa',
  'papua-new-guinea': 'pg',
  'paraguay': 'py',
  'peru': 'pe',
  'philippines': 'ph',
  'poland': 'pl',
  'portugal': 'pt',
  'qatar': 'qa',
  'romania': 'ro',
  'russia': 'ru',
  'rwanda': 'rw',
  'saint-kitts-and-nevis': 'kn',
  'saint-lucia': 'lc',
  'saint-vincent-and-the-grenadines': 'vc',
  'samoa': 'ws',
  'san-marino': 'sm',
  'sao-tome-and-principe': 'st',
  'saudi-arabia': 'sa',
  'senegal': 'sn',
  'serbia': 'rs',
  'seychelles': 'sc',
  'sierra-leone': 'sl',
  'singapore': 'sg',
  'slovakia': 'sk',
  'slovenia': 'si',
  'solomon-islands': 'sb',
  'somalia': 'so',
  'south-africa': 'za',
  'south-korea': 'kr',
  'south-sudan': 'ss',
  'spain': 'es',
  'sri-lanka': 'lk',
  'sudan': 'sd',
  'suriname': 'sr',
  'sweden': 'se',
  'switzerland': 'ch',
  'syria': 'sy',
  'taiwan': 'tw',
  'tajikistan': 'tj',
  'tanzania': 'tz',
  'thailand': 'th',
  'timor-leste': 'tl',
  'togo': 'tg',
  'tonga': 'to',
  'trinidad-and-tobago': 'tt',
  'tunisia': 'tn',
  'turkey': 'tr',
  'turkmenistan': 'tm',
  'tuvalu': 'tv',
  'uganda': 'ug',
  'ukraine': 'ua',
  'united-arab-emirates': 'ae',
  'united-kingdom': 'gb',
  'united-states': 'us',
  'uruguay': 'uy',
  'uzbekistan': 'uz',
  'vanuatu': 'vu',
  'vatican-city': 'va',
  'venezuela': 've',
  'vietnam': 'vn',
  'yemen': 'ye',
  'zambia': 'zm',
  'zimbabwe': 'zw',
};

/** Dial code (without +) for react-phone-input-2 country codes (iso2 lowercase). */
export const countryCodeToDialCode: Record<string, string> = {
  af: '93',
  al: '355',
  dz: '213',
  ad: '376',
  ao: '244',
  ag: '1268',
  ar: '54',
  am: '374',
  aw: '297',
  au: '61',
  at: '43',
  az: '994',
  bs: '1242',
  bh: '973',
  bd: '880',
  bb: '1246',
  by: '375',
  be: '32',
  bz: '501',
  bj: '229',
  bt: '975',
  bo: '591',
  ba: '387',
  bw: '267',
  br: '55',
  io: '246',
  bn: '673',
  bg: '359',
  bf: '226',
  bi: '257',
  kh: '855',
  cm: '237',
  ca: '1',
  cv: '238',
  bq: '599',
  cf: '236',
  td: '235',
  cl: '56',
  cn: '86',
  co: '57',
  km: '269',
  cd: '243',
  cg: '242',
  cr: '506',
  ci: '225',
  hr: '385',
  cu: '53',
  cw: '599',
  cy: '357',
  cz: '420',
  dk: '45',
  dj: '253',
  dm: '1767',
  do: '1',
  ec: '593',
  eg: '20',
  sv: '503',
  gq: '240',
  er: '291',
  ee: '372',
  et: '251',
  fj: '679',
  fi: '358',
  fr: '33',
  gf: '594',
  pf: '689',
  ga: '241',
  gm: '220',
  ge: '995',
  de: '49',
  gh: '233',
  gr: '30',
  gd: '1473',
  gp: '590',
  gu: '1671',
  gt: '502',
  gn: '224',
  gw: '245',
  gy: '592',
  ht: '509',
  hn: '504',
  hk: '852',
  hu: '36',
  is: '354',
  in: '91',
  id: '62',
  ir: '98',
  iq: '964',
  ie: '353',
  il: '972',
  it: '39',
  jm: '1876',
  jp: '81',
  jo: '962',
  kz: '7',
  ke: '254',
  ki: '686',
  xk: '383',
  kw: '965',
  kg: '996',
  la: '856',
  lv: '371',
  lb: '961',
  ls: '266',
  lr: '231',
  ly: '218',
  li: '423',
  lt: '370',
  lu: '352',
  mo: '853',
  mk: '389',
  mg: '261',
  mw: '265',
  my: '60',
  mv: '960',
  ml: '223',
  mt: '356',
  mh: '692',
  mq: '596',
  mr: '222',
  mu: '230',
  mx: '52',
  fm: '691',
  md: '373',
  mc: '377',
  mn: '976',
  me: '382',
  ma: '212',
  mz: '258',
  mm: '95',
  na: '264',
  nr: '674',
  np: '977',
  nl: '31',
  nc: '687',
  nz: '64',
  ni: '505',
  ne: '227',
  ng: '234',
  kp: '850',
  no: '47',
  om: '968',
  pk: '92',
  pw: '680',
  ps: '970',
  pa: '507',
  pg: '675',
  py: '595',
  pe: '51',
  ph: '63',
  pl: '48',
  pt: '351',
  pr: '1',
  qa: '974',
  re: '262',
  ro: '40',
  ru: '7',
  rw: '250',
  kn: '1869',
  lc: '1758',
  vc: '1784',
  ws: '685',
  sm: '378',
  st: '239',
  sa: '966',
  sn: '221',
  rs: '381',
  sc: '248',
  sl: '232',
  sg: '65',
  sk: '421',
  si: '386',
  sb: '677',
  so: '252',
  za: '27',
  kr: '82',
  ss: '211',
  es: '34',
  lk: '94',
  sd: '249',
  sr: '597',
  sz: '268',
  se: '46',
  ch: '41',
  sy: '963',
  tw: '886',
  tj: '992',
  tz: '255',
  th: '66',
  tl: '670',
  tg: '228',
  to: '676',
  tt: '1868',
  tn: '216',
  tr: '90',
  tm: '993',
  tv: '688',
  ug: '256',
  ua: '380',
  ae: '971',
  gb: '44',
  us: '1',
  uy: '598',
  uz: '998',
  vu: '678',
  va: '39',
  ve: '58',
  vn: '84',
  ye: '967',
  zm: '260',
  zw: '263',
};

const dialCodeToCountryCode: Record<string, string> = Object.entries(countryCodeToDialCode).reduce(
  (acc, [countryCode, dialCode]) => {
    if (!acc[dialCode]) acc[dialCode] = countryCode;
    return acc;
  },
  {} as Record<string, string>
);

const phoneCountryCodeToLocation: Record<string, string> = Object.entries(countryToPhoneCode).reduce(
  (acc, [locationValue, countryCode]) => {
    if (!acc[countryCode]) acc[countryCode] = locationValue;
    return acc;
  },
  {} as Record<string, string>
);

export function normalizeCountryLookupKey(country: string): string {
  return (country || '')
    .toLowerCase()
    .trim()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** Get phone input country code (iso2, lowercase) from location value/label. */
export function getPhoneCountryFromLocation(location: string): string | undefined {
  if (!location || typeof location !== 'string') return undefined;
  const key = normalizeCountryLookupKey(location);
  return countryToPhoneCode[key];
}

/** Get dial code (e.g. "91") for a react-phone-input-2 country code (e.g. "in"). Returns "1" for unknown. */
export function getDialCodeForCountryCode(countryCode: string): string {
  if (!countryCode || typeof countryCode !== 'string') return '1';
  const code = countryCode.toLowerCase().trim();
  return countryCodeToDialCode[code] ?? '1';
}

/** Get country code (e.g. "af") from dial code with or without "+" (e.g. "+93" or "93"). Returns "us" if unknown. */
export function getCountryCodeFromDialCode(dialCode: string): string {
  if (!dialCode || typeof dialCode !== 'string') return 'us';
  const normalized = dialCode.replace(/^\+/, '').trim();
  return dialCodeToCountryCode[normalized] ?? 'us';
}

/** Get location value used by country selects (e.g. "united-states") from phone country code (iso2 e.g. "us"). */
export function getLocationFromPhoneCountryCode(countryCode: string): string | undefined {
  if (!countryCode || typeof countryCode !== 'string') return undefined;
  return phoneCountryCodeToLocation[countryCode.toLowerCase().trim()];
}

/** Get location value used by country selects from dial code with or without "+". */
export function getLocationFromDialCode(dialCode: string): string | undefined {
  const countryCode = getCountryCodeFromDialCode(dialCode);
  return getLocationFromPhoneCountryCode(countryCode);
}
